import React from 'react';

/**
 * App Launcher tipo Odoo: grid de aplicaciones agrupadas por categoría.
 * Muestra tarjetas grandes clickeables con ícono + nombre + categoría.
 */
const AppLauncher = ({ availableTabs = [], categoryOrder = [], categoryMeta = {}, onOpen, user, hideWelcome = false }) => {
  return (
    <div className={hideWelcome ? '' : 'min-h-[calc(100vh-140px)]'} data-testid="app-launcher">
      {/* Bienvenida (oculta cuando se usa dentro del overlay) */}
      {!hideWelcome && (
        <div className="mb-6 bg-gradient-to-r from-indigo-600 via-blue-600 to-cyan-600 rounded-2xl p-6 text-white shadow-lg">
          <h1 className="text-2xl font-bold mb-1">Hola{user?.username ? `, ${user.username}` : ''} 👋</h1>
          <p className="text-blue-100 text-sm">Selecciona una aplicación para comenzar. Tienes <b>{availableTabs.length}</b> apps disponibles.</p>
        </div>
      )}

      {/* Grid de apps por categoría */}
      {categoryOrder.map((cat) => {
        const meta = categoryMeta[cat] || {};
        const apps = availableTabs.filter((t) => t.category === cat);
        if (apps.length === 0) return null;
        return (
          <section key={cat} className="mb-8" data-testid={`launcher-cat-${cat.replace(/[^a-z0-9]+/gi, '-')}`}>
            <div className="flex items-center gap-2 mb-3">
              <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${meta.color || 'from-slate-500 to-slate-700'} text-white flex items-center justify-center font-bold`}>
                {meta.emoji || '📦'}
              </div>
              <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider">{cat}</h2>
              <div className="flex-1 h-px bg-slate-200"></div>
              <span className="text-[10px] font-mono text-slate-400">{apps.length} app{apps.length !== 1 ? 's' : ''}</span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
              {apps.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => onOpen?.(tab.id)}
                  className={`group relative border-2 ${meta.bg || 'bg-slate-50 border-slate-200 hover:bg-slate-100'} rounded-xl p-4 flex flex-col items-center gap-2 shadow-sm hover:shadow-md hover:scale-[1.03] active:scale-[0.98] transition-all duration-150`}
                  title={tab.label}
                  data-testid={`launcher-app-${tab.id}`}
                >
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${meta.color || 'from-slate-500 to-slate-700'} text-white flex items-center justify-center text-3xl shadow-md group-hover:shadow-lg transition-shadow`}>
                    {tab.icon}
                  </div>
                  <div className={`text-xs font-bold text-center leading-tight ${meta.text || 'text-slate-800'}`}>
                    {tab.label}
                  </div>
                </button>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default AppLauncher;
